import {RefObject} from "react";
import {scrollToPanel} from "./FormNavigation";

interface FormNavigationCardProps {
  label: string;
  formContainerRef: RefObject<HTMLDivElement | HTMLFormElement>;
  targetPanelRef: RefObject<HTMLDivElement>;
}

export default function FormNavigationCard({
                                             label,
                                             formContainerRef,
                                             targetPanelRef
                                           }: FormNavigationCardProps) {
  /*
   * This will be used to give each instance of this component a unique ID based on its title. It will replace spaces
   * with _
   */
  const componentLabelForId = `nav_card_${label.toLowerCase().replace(' ', '_')}`;

  return <a id={componentLabelForId}
            className={"nav-card"}
            onClick={() => scrollToPanel(formContainerRef, targetPanelRef)}>
    {label}<i className="arrow bi bi-arrow-right"></i>
  </a>;
}